<template>
    <v-menu bottom offset-y  :close-on-content-click="false">
        <template v-slot:activator="{ on: menu, attrs }">
			<v-tooltip bottom >
				<template v-slot:activator="{on:tooltip}">
					<v-btn 
                       	icon						
                        v-on   = "{ ...tooltip, ...menu}"     
                        v-bind="attrs"                    
		                class  = "mb-1"
		                ref = "menuNotification"
					>
						<v-badge 
		                    offset-x="8"
		                    offset-y="15"
		                    bottom
		                    overlap
		                    color   = "error"
		                    :content = "notices.length?notices.length:'0'"		   

		                >
		                  	<v-icon>mdi-bell</v-icon>
		                </v-badge>				
					</v-btn>	
					<div>
						
					<v-snackbar 
						v-model="snackbar"  
						@input="onSnackbarInput"
						:timeout="timeout"
          				ref="snackbar" 
          				top 
          				right
          				app
						:key 	 = "'snackbarNotifices'"

          				
          			>
          				<v-row no-gutters class="py-0" >
          					<v-col 
          						xl   = "11" 
								lg   = "11" 
								md 	 = "11" 
								xs 	 = "11" 
								cols = "11"
          					>
				  				<v-icon small class="ml-1" color="warning"> mdi-alert</v-icon>
				  				<strong> {{$ml.get('device')}} : {{info.name}} </strong>
				  				
			  					<v-row dense>
			  						<v-col cols="2">
			  							<v-icon large class="mt-1" :color="info.color"> {{info.icon}}</v-icon>				  							
			  						</v-col>
			  						<v-col cols="10">
					  					{{ info.text }} <br>
					  					<strong>{{info.date}}</strong>			  							
			  						</v-col>
			  					</v-row> 
          					</v-col>
          					<v-col 
          						xl   = "1" 
								lg   = "1" 
								md   = "1" 
								xs   = "1" 
								cols = "1"
          					>
          						<v-btn
									icon
									dark
									small
									outlined
									color  = "error"
									class  = "elevation-5 error"
									@click = "snackbar = false"
								>
									<v-icon 
										small 						
										color  = "white"
									>
										mdi-close
									</v-icon>
								</v-btn>
          					</v-col>
          				</v-row>
					</v-snackbar>			
					</div>
				</template>
				<span> {{ $ml.get("notifications") }}</span>
			</v-tooltip>
		</template>
			<v-card  max-height="450">
			<v-list dense  >
				<v-list-item link v-if="renderListNotifications.length === 0" >
					<v-list-item-content>
					<v-list-item-title>{{ $ml.get('no_pending_notifications') }}</v-list-item-title>					
					</v-list-item-content>					
				</v-list-item >
				<template  v-for="(item, index) in renderListNotifications" 	>
					<v-divider :key="index"></v-divider>
	          			<!-- 
					<v-list-group
				        :value="false"			       		        
				    >
	          				sub-group -->
	          		<v-list-item :key="item.deviceId || index">
	          			<v-list-item-avatar>
				          	<v-icon  :color="item.color || 'warning'">{{ item.icon || 'mdi-account-circle'}}</v-icon>	
				        </v-list-item-avatar>
					    	<!-- <template v-slot:prependIcon>
					    		<v-icon class="mt-3" :color="item.color || 'warning'">{{ item.icon || 'mdi-account-circle'}}</v-icon>	
					    	</template>
					    	<template v-slot:appendIcon>
					    		<v-icon color="white">mdi-close</v-icon>	
					    	</template> -->
			        	<!-- <template v-slot:activator> -->
						<v-list-item-content>
			          		<v-list-item-title>{{ item.name }}</v-list-item-title>
							<v-list-item-subtitle> {{ item.text }} <v-spacer></v-spacer> {{ item.date }}</v-list-item-subtitle>
							<!-- <v-list-item-action>
								<v-btn small icon @click="closeNotice(item)">
									<v-icon small>mdi-close</v-icon>
								</v-btn>
							</v-list-item-action> -->
						</v-list-item-content>
						<v-list-item-action>
				          	<v-btn icon @click="closeNotice(item)">
				            	<v-icon color="white">mdi-close</v-icon>	
				          	</v-btn>
				        </v-list-item-action>
			        	<!-- </template> -->
						<!-- <v-list-item  class="justify-center">
				        	<v-card >
				        		<v-divider></v-divider>				        		
				        		<v-card-actions class="justify-center">
				        			<v-btn small color="success" @click="confirmNotice(item)" :disabled="item.isConfirmed">{{ item.isConfirmed ? $ml.get('confirmed') : $ml.get('confirm') }}</v-btn>
				        			<v-btn small color="error" @click="closeNotice(item)">{{$ml.get('close')}}</v-btn>
				        		</v-card-actions>
								
				        	</v-card>
						</v-list-item > -->
					</v-list-item>
					<!-- </v-list-group> -->
				</template>
						

			</v-list>		
			</v-card>	
	</v-menu>
</template>

<script>
	export default{
		name: 'MenuNotifications',
		data: () => ({
			snackbar : false,
			timeout: 5000,
			notices:[],
			bus : {},
			info : { name: "", text : " ", date : "", icon : "mdi-alert", color : "warning"},			
			interval : null,
			timeoutPopup : null,
			isSoundActive : true,
			popups : [],
		}),

		mounted(){			
			this.$EventBus.$on("events_technical_menu_notifications", this.bus.events_technical_mapview = (action)=>{				
				this.renderNotification(action);
			});
			this.$EventBus.$on("events_technical", this.bus.events_technical=(action)=>{
				this.renderNotification(action);				
			});						
			this.$EventBus.$on("confirmation-notification", this.bus.events_technical=(action)=>{
				this.renderNotification(action);				
			});						
			

			const timer = setTimeout(()=>{
				this.$EventBus.$emit("getListTechnicals");				
				clearTimeout(timer)
			}, 1500);
			// this.interval = setInterval(()=>{
			// 	this.renderIsNotConfirmed();
			// },30000)

			//setInterval(()=>{this.showSnackbar();}, 3000) 
		},
		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, "notificationsMenu");
			clearInterval(this.interval);
			
			// Limpiar timeout adicional
			if (this.timeoutPopup) {
				clearTimeout(this.timeoutPopup);
				this.timeoutPopup = null;
			}
			
			// Limpiar EventBus listeners específicos
			this.$EventBus.$off("events_technical_menu_notifications", this.bus.events_technical_mapview);
			this.$EventBus.$off("events_technical", this.bus.events_technical);
			this.$EventBus.$off("confirmation-notification", this.bus.events_technical);
		},
		computed:{
			renderListNotifications: function(){
				return this.notices;
			}
		},
		methods:{
			playSound(){
				if (this.$Sounds.getIsSoundActive()) {
					this.$Sounds.play("alertDevice");
				}
			},
			stopSound(){
				this.$Sounds.stop("alertDevice");				
			},
			renderIsNotConfirmed(){
				if (this.notices && this.notices.length > 0) {
					const num = this.notices.filter(x => x && !x.isConfirmed && x.state != 0)
					if (num && num.length > 0) {
						this.playSound();
		          		// this.addBounceAnimationMenu();						
					}
				}
			},	
			renderNotification(item){
				if (item) {
					// console.log("menu NotificationTechnicals ---------------------- ", item)
					if (item.deviceId && ((item.code && (item.code.includes("BK_RETRASMISSION_LOCAL") || item.code.includes("BK_RETRASMISSION_CLOUD") || item.code.includes("BK_RTSP_"))) || item.isNotification )) {
						if (item.state == 0) {
							const idx = this.notices.findIndex(x => x.deviceId == item.deviceId)							
							if (idx >= 0) {
								this.notices.splice(idx, 1);
							}
						}else {

							const idx = this.notices.findIndex(x => x.deviceId == item.deviceId)
								// update 
							let iconTemp  = item.icon || item.icon_code;
							let colorTemp = item.color || item.color_tag;
							let dateTemp  = item.date ?  item.date : this.$Format.currentDateGuess();
							let titleTemp = item.name || item.device;
							let textTemp  = item.code ? this.$ml.get(item.code) : item.detail; 

							if (idx >= 0 ) {
								this.notices.splice(idx, 1, {
									 // ...item, 
									deviceId: item.deviceId,
									name: titleTemp,
									text : textTemp, 
									date : dateTemp,
									icon : iconTemp,
									color : colorTemp,
								});							
								// add 								
							}else{
								this.notices.unshift({
									 // ...item, 
									deviceId: item.deviceId,
									name: titleTemp, 
									text : textTemp, 
									date : dateTemp,
									icon : iconTemp,
									color : colorTemp,
									isConfirmed : false, 
								});				

							}
							this.popups.push({
								deviceId : item.deviceId,
								name : titleTemp,
								text : textTemp,
								date : dateTemp,
								icon : iconTemp,
								color : colorTemp,
							});
							this.renderPopUp();
							
						}
					}
					/*else if(item.name ){
						// console.log("NOtices ----------- ", this.notices)	
						const idx = this.notices.findIndex(x => x.name == item.name)
						if (idx >= 0) {
							this.notices.splice(idx,1, {...item, text : this.$ml.get(item.code), title: item.name});														
						}else{							
							this.notices.push({...item, text : this.$ml.get(item.code), title: item.name, isConfirmed : false });
						}
						this.info.name = item.name;
						this.info.text = this.$ml.get(item.code);
					}*/
					
				}

			},
			renderPopUp(){
				if (!this.timeoutPopup) {
					if (this.popups.length > 0) {					
						const item = this.popups.shift()
						this.info = item;
						//this.showSnackbar();				
						//this.playSound();
						// console.log("Before start pop up ")
						this.timeoutPopup = setTimeout(()=>{
							clearTimeout(this.timeoutPopup);
							this.timeoutPopup = null;
							// console.log("end pop up ")
							if (this.popups.length > 0) {
								this.renderPopUp();
							}
						}, this.timeout)
					}

				}

			},
			confirmNotice(item){
				const idx = this.notices.indexOf(item);
				if (idx>=0) {
					item.isConfirmed = true;
					this.notices.splice(idx, 1, {...item});

				}
			},
			closeNotice(item){
				const idx = this.notices.indexOf(item);
				if (idx >= 0) {
					this.notices.splice(idx, 1);
				}
			},
			addBounceAnimation() {
		      	this.$nextTick(() => {
		        	const snackbarEl = this.$refs.snackbar.$el;
		        	snackbarEl.classList.add('bounce-enter-active');
		        	snackbarEl.addEventListener('animationend', () => {
		          		snackbarEl.classList.remove('bounce-enter-active');
		          		this.addBounceAnimationMenu();
		        	}, { once: true });
		      	});
		    },
		    addBounceAnimationMenu() {
		      	this.$nextTick(() => {
		        	const menuEl = this.$refs.menuNotification.$el;
		        	menuEl.classList.add('bounce-enter-active');
		        	menuEl.addEventListener('animationend', () => {
		          		menuEl.classList.remove('bounce-enter-active');
		        	}, { once: true });
		      	});
		    },
		    onSnackbarInput(value) {
		    	// console.log("CLose snackar input ", value)
		      	if (!value) {
			        this.snackbar = false;
			    }
			},
			
			showSnackbar() {
		      	this.snackbar = true;		      	
		       	// this.addBounceAnimation();		      
		    },		 
		}, // methods
	}
</script>
<style scoped>
	@keyframes bounce {
	  0%, 20%, 50%, 80%, 100% {
	    transform: translateY(0);
	  }
	  40% {
	    transform: translateY(-30px);
	  }
	  60% {
	    transform: translateY(-15px);
	  }
	}
	.bounce-enter-active {
	  animation: bounce 0.5s !important;
	}	
	.bounce {		
	  animation: bounce 0.5s !important;
	}

</style>